export enum BannerLocation {
    HEADER = 'header',
    APPLIANCE_LISTING = 'appliance-listing'
}
